module.exports = __webpack_public_path__ + "img/weixin.42c71f93.png";